export const buildBankConciliationPayload = (ids, rows, editedAmounts) => {
  const amounts = new Map()
  for (const row of rows) {
    const key = row.id ?? row.idPrincipal
    if (row.customRow || !Object.prototype.hasOwnProperty.call(editedAmounts, key)) continue
    const id = Number(row.idPrincipal ?? row.id)
    if (Number.isFinite(id) && id > 0) amounts.set(id, editedAmounts[key])
  }
  const unchanged = [...new Set(ids.map(Number))].filter(id => Number.isFinite(id) && id > 0 && !amounts.has(id))
  return {
    ids: unchanged,
    ...(amounts.size ? { montoId: [...amounts].map(([id, monto]) => ({ id, monto })) } : {})
  }
}

export const routeEditedConciliationAmounts = (bank, compensation) => {
  const editedAmounts = [...(bank.montoId ?? []), ...(compensation.montoId ?? [])]
  const editedIds = new Set(editedAmounts.map(item => item.id))
  const datoBanco = {
    ids: [...new Set([...bank.ids, ...compensation.ids])].filter(id => !editedIds.has(id))
  }
  const datoBoleta = editedAmounts.length ? editedAmounts : { ids: [] }
  return {
    datoBanco,
    datoBoleta,
    instrucciones: [datoBanco.ids.length > 0,
      editedAmounts.length > 0, false, false]
  }
}
